import TagsModel from '../Apis/Tags'
import Controller from './Controller'

export default class TagsController extends Controller {
  constructor() {
    super(new TagsModel())
  }
}
